import React, { useState } from "react";
import axios from "axios";
import "./Dictionary.css";
import Results from "./Results";
import { TailSpin } from "react-loader-spinner";
import Photos from "./Photos";
import Error from "./Error";

export default function Dictionary(props) {
  let [keyword, setKeyword] = useState(props.defaultKeyWord); //state for displaying and changing search input
  let [results, setResults] = useState(null); //state for dispplaying changing results
  let [loaded, setLoaded] = useState(false); //state for checking wether content loaded or not
  let [photos, setPhotos] = useState(null); //state for displaying photoes
  let [error, setError] = useState(null); //state for displaying error

  function handleError(error) {
    // Error
    if (error.response.data.title === "No Definitions Found") {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // console.log(error.response.data);
      setError(error.response.data);
      setResults(null);

      // console.log(error.response.headers);
    } else {
      // Something happened in setting up the request that triggered an Error
      setError(error.response.data);
    }
  }

  function handleSearch(event) {
    //onckick event for pressing Saearch
    //handele search input
    event.preventDefault();

    if (keyword.trim().length !== 0) {
      //if field is NOT empty
      search(); //call APIs
    } else {
      setError("input value is empty"); //show messege
    }
  }
  function handleSubmit(event) {
    //if search input changed
    event.preventDefault();
    setKeyword(event.target.value); //change keyword state
  }
  function search() {
    let apiURL = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`; //build API url
    axios.get(apiURL).then(handleDictionaryResponse).catch(handleError);

    //using axios 1 - using url send keyword 2 - then recieve response

    let unsplashApiKey = "J9E-O2oR0EVj1jPOEut_mJFqnig03uGVk4IU_d7iEFQ";
    let unsplashApiURL = `https://api.unsplash.com/search/photos?page=1&query=${keyword}&client_id=${unsplashApiKey}&per_page=6&orientation=landscape`; //build API url
    axios.get(unsplashApiURL).then(handleUnsplashResponse); //using axios 1 - usin url send keyword 2 - then recieve response
  }

  function handleDictionaryResponse(response) {
    //handle axios response from Dictionary
    //https://dictionaryapi.dev/ - documentation
    setError(null);
    setResults(response.data[0]); //set axios response as result state
  }

  function handleUnsplashResponse(response) {
    //handle axios response from Unsplash
    setPhotos(response.data.results); //set state for Photos
  }

  function load() {
    search();
    setLoaded(true);
  }

  if (loaded) {
    if (error) {
      return (
        <div className="Dictionary">
          <h1 className="mt-5 mb-3 text-center">✨ Awesome Dictionary</h1>
          <section className="Search">
            <form onSubmit={handleSearch} className="ps-3 pe-3">
              <h2 className="mt-1 mb-1 title">
                What word do you want to look up?
              </h2>
              <div className="row">
                <div className="col-9">
                  <input
                    type="search"
                    placeholder="Search for a word"
                    autoFocus
                    onChange={handleSubmit}
                    className="search-input"
                    defaultValue={props.defaultKeyWord}
                  ></input>
                </div>
                <div className="col-3">
                  <input
                    id="keyword"
                    type="submit"
                    value="Search"
                    className="search-btn"
                  ></input>
                </div>
              </div>
            </form>
            <span className="hint">
              suggested words: rain, yoga, wine, hike
            </span>
          </section>
          <Error error={error} />
        </div>
      );
    } else {
      return (
        <div className="Dictionary">
          <h1 className="mt-5 mb-3 text-center ">✨ Awesome Dictionary</h1>
          <section className="Search">
            <form onSubmit={handleSearch} className="ps-3 pe-3">
              <h2 className="mt-1 mb-1 title ">
                What word do you want to look up?
              </h2>
              <div className="row">
                <div className="col-9">
                  <input
                    type="search"
                    placeholder="Search for a word"
                    autoFocus
                    onChange={handleSubmit}
                    className="search-input"
                    defaultValue={props.defaultKeyWord}
                  ></input>
                </div>
                <div className="col-3">
                  <input
                    id="keyword"
                    type="submit"
                    value="Search"
                    className="search-btn"
                  ></input>
                </div>
              </div>
            </form>
            <span className="hint">
              suggested words: rain, yoga, wine, hike
            </span>
          </section>

          <Results results={results} />
          <Photos photos={photos} />
        </div>
      );
    }
  } else {
    load();

    return (
      <TailSpin
        height="80"
        width="80"
        radius="9"
        color="#005792"
        wrapperStyle
        wrapperClass
      />
    );
  }
}
